import { lazy } from 'react';
import { Loadable } from './loadable';

// Auth
export const LoginPage = Loadable(lazy(() => import('../_authentication/login')));
export const RegisterPage = Loadable(lazy(() => import('../_authentication/register')));
export const ResetPasswordPage = Loadable(lazy(() => import('../_authentication/reset-password')));
export const NewPasswordPage = Loadable(lazy(() => import('../_authentication/new-password')));
export const VerifyCodePage = Loadable(lazy(() => import('../_authentication/verify-code')));

// Dashboard — Overview & core
export const PersonalLearningPage = Loadable(lazy(() => import('../pages/personal-learning-page')));
export const UpNextPage = Loadable(lazy(() => import('../pages/up-next-page')));
export const FlashcardReviewPage = Loadable(lazy(() => import('../pages/flashcard-review-page')));
export const NotificationsPage = Loadable(lazy(() => import('../pages/notifications-page')));

// Dashboard — Pathways
export const PathwayBuilderPage = Loadable(lazy(() => import('../features/pathway-builder')));
export const PathwayCreatePage = Loadable(lazy(() => import('../pages/pathway-create-page')));
export const PathwaysPage = Loadable(lazy(() => import('../pages/pathways-page')));
export const TopicEditSinglePage = Loadable(lazy(() => import('../pages/topic-edit-single-page')));
export const ImmersivePathwayPage = Loadable(lazy(() => import('../pages/pathway-immersive-page')));

// Dashboard — Explore
export const ExplorePathwaysPage = Loadable(lazy(() => import('../pages/explore-pathways-page')));
export const ExplorePathwayViewPage = Loadable(
  lazy(() => import('../pages/explore-pathway-view-page'))
);
export const ExplorePathwayFollowingPage = Loadable(
  lazy(() => import('../pages/explore-pathway-following-page'))
);
export const ExplorePathwayFollowingViewerPage = Loadable(
  lazy(() => import('../pages/explore-pathway-following-viewer-page'))
);
export const ExplorePathwaySharedPage = Loadable(
  lazy(() => import('../pages/explore-pathway-shared-page'))
);
export const ExplorePathwaySharedViewerPage = Loadable(
  lazy(() => import('../pages/explore-pathway-shared-viewer-page'))
);
export const SuggestionsPage = Loadable(lazy(() => import('../pages/suggestions-page')));

// Dashboard — Circles
export const CirclesPage = Loadable(lazy(() => import('../pages/circles-page')));
export const CircleCreatePage = Loadable(lazy(() => import('../pages/circle-create-page')));
export const CircleDetailsPage = Loadable(lazy(() => import('../pages/circle-details-page')));
export const CircleActivityPage = Loadable(lazy(() => import('../pages/circle-activity-page')));
export const AIContentPage = Loadable(
  lazy(() => import('../pages/circle-details-page/ai-content'))
);

// Dashboard — External platforms
export const ExternalPlatformsPage = Loadable(
  lazy(() => import('../pages/external-platforms-page'))
);

// Dashboard — User
export const UserAccountPage = Loadable(lazy(() => import('../pages/user-account-page')));
export const ReportProblemPage = Loadable(lazy(() => import('../pages/report-problem-page')));

// Dashboard — Admin
export const AdminPage = Loadable(lazy(() => import('../_admin-pages')));
export const AdminOrganizationsPage = Loadable(lazy(() => import('../_admin-pages/organizations')));
export const AdminOrganizationDetailPage = Loadable(
  lazy(() => import('../_admin-pages/organization-details'))
);
export const TopicMigrationPage = Loadable(lazy(() => import('../_admin-pages/topic-migration')));
export const ResourceMigrationPage = Loadable(
  lazy(() => import('../_admin-pages/resource-migration'))
);
export const LearningCyclesPage = Loadable(lazy(() => import('../_admin-pages/learning-cycles')));
export const ResearchOverviewPage = Loadable(lazy(() => import('../_research-pages/overview')));
export const OrgOverviewPage = Loadable(lazy(() => import('../_org-pages/overview')));
export const OrgMembersPage = Loadable(lazy(() => import('../_org-pages/members')));
export const OrgCirclesPage = Loadable(lazy(() => import('../_org-pages/circles')));
export const OrgCircleCreatePage = Loadable(lazy(() => import('../_org-pages/circle-create')));
export const OrgPathwaysPage = Loadable(lazy(() => import('../_org-pages/pathways')));
export const OrgPathwayCreatePage = Loadable(lazy(() => import('../_org-pages/pathway-create')));

export const InvitationPage = Loadable(lazy(() => import('../pages/invitation')));

// Public
export const LandingPage = Loadable(lazy(() => import('../_external-pages/LandingPage')));
export const TermsPage = Loadable(lazy(() => import('../_external-pages/Terms')));
export const PrivacyPolicyPage = Loadable(lazy(() => import('../_external-pages/PrivacyPolicy')));
export const ComingSoonPage = Loadable(lazy(() => import('../_external-pages/ComingSoon')));
export const MaintenancePage = Loadable(lazy(() => import('../_external-pages/Maintenance')));
export const Page500 = Loadable(lazy(() => import('../_external-pages/Page500')));
export const NotFoundPage = Loadable(lazy(() => import('../_external-pages/Page404')));
